const CONTROL_CHARACTERS = /[\u0000-\u001f\u007f]/;

export function sanitizePortalUrl(rawUrl) {
  if (typeof rawUrl !== "string") return null;
  const value = rawUrl.trim();
  if (!value || CONTROL_CHARACTERS.test(value) || value.includes("\\")) return null;
  if (value.startsWith("//")) return null;

  try {
    const base = typeof window !== "undefined" ? window.location.origin : "http://localhost";
    const parsed = new URL(value, base);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return null;
    const sameOrigin = parsed.origin === new URL(base).origin;
    if (sameOrigin) {
      const path = parsed.pathname.toLowerCase();
      if (path === "/api" || path.startsWith("/api/")) return null;
      const allowed = ["/home", "/portal", "/box", "/ccon", "/tabl", "/hapk", "/mfm", "/exhi", "/champ"];
      if (!allowed.some((prefix) => path === prefix || path.startsWith(prefix + "/"))) return null;
      return parsed.pathname + parsed.search + parsed.hash;
    }
    if (!/^[a-z][a-z0-9+.-]*:/i.test(value)) return null;
    return parsed.href;
  } catch (_) {
    return null;
  }
}

export function isExternalPortalUrl(url) {
  if (!url || typeof window === "undefined") return false;
  try {
    return new URL(url, window.location.origin).origin !== window.location.origin;
  } catch (_) {
    return false;
  }
}

const APP_ROUTES = Object.freeze({
  CUBE: "/home", CUBERITE: "/home", BOX: "/box", CCON: "/ccon",
  TABL: "/tabl", HAPK: "/hapk", MFM: "/mfm", EXHI: "/exhi", CHAMP: "/champ",
});

export function resolvePortalLink(link) {
  const explicit = sanitizePortalUrl(link?.url);
  if (explicit) return explicit;
  const kind = String(link?.kind || "").toUpperCase();
  const targetId = String(link?.targetId || "").trim();
  if (!targetId) return null;
  const encoded = encodeURIComponent(targetId);
  if (kind === "DOCUMENT") return "/portal/documentos/" + encoded;
  if (kind === "TEST" || kind === "PRUEBA") return "/portal/documentos/" + encoded;
  if (kind === "DEPENDENCY" || kind === "DEPENDENCIA") {
    return "/portal/roadmap#portal-item-" + encoded;
  }
  if (kind === "APP" || kind === "APPLICATION") {
    return APP_ROUTES[targetId.toUpperCase()] || null;
  }
  return null;
}
